export enum BestPlanSteps {
  FD_DETAILS_STEP = 'FD_DETAILS_STEP',
  INPUT_STEP = 'INPUT_STEP',
  INVESTMENT_SUMMARY_STEP = 'INVESTMENT_SUMMARY_STEP',
  PROGRESS_STEP = 'PROGRESS_STEP'
}

export enum FundTypeEnum {
  BANK = 'BANK',
  NBFC = 'NBFC'
}

export type FundType = `${FundTypeEnum}`

export interface FDInvestmentJourneyResponseType {
  responseType: string
  responseName: string
  institutionName: string
  institutionId: string
  interestRate: number
  averageInterestRate: number
  minInvestableAmount: number
  maxInvestableAmount: number
  lockInPeriodInDays: number
  fundType: FundType
  tenure: number
  maturityTime: number
  planSecuredBy: string
  logoUrl: string
}

export function calculateYield(interestRate: number, yearlyCompoundingFrequency: number): number {
  if (interestRate > 0 && yearlyCompoundingFrequency > 0 && yearlyCompoundingFrequency <= 365) {
    const rateDecimal = interestRate / 100.0
    const ear = Math.pow(1.0 + rateDecimal / yearlyCompoundingFrequency, yearlyCompoundingFrequency) - 1.0
    // Round to two decimal places
    return Math.round(ear * 100) / 100
  } else {
    return 0.0
  }
}
